import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getArticleContent, getArticleDetail } from '../../views/article-detail/article-detail.actions';
import ArticleModalView from './article-modal.presenter';

// Map & Connect
export const mapStateToProps = state => ({
  contentLoading: state.articleDetailReducer.contentLoading,
  articleContent: state.articleDetailReducer.articleContent,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ getArticleContent, getArticleDetail }, dispatch),
});

const ArticleModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArticleModalView);

export default ArticleModal;
